import {
  Injectable,
  InjectionToken,
  ComponentRef,
  ComponentFactoryResolver,
  Injector,
} from "@angular/core";
import { ValidationErrors, AbstractControl } from "@angular/forms";
import { FieldType } from "./../templates/field.type";
import { reverseDeepMerge, defineHiddenProp } from "./../utils";
import {
  KreFormFieldConfig,
  KreFormFieldConfigCache,
} from "../components/kre-form.field.config";
// import * as crypto from "crypto-js";
import * as moment_ from "moment";
import { Default_CODE } from "../tools/config";
const moment = moment_;

export const KreFormOtherConfig = new InjectionToken<KreFormOther>(
  "KREFORMOTHER"
);

export interface LicenseOption {
  url: string;
  config: string;
}

@Injectable({ providedIn: "root" })
export class KreFormOther {
  option: LicenseOption = null;
  types: { [name: string]: any } = {};
  _config = Default_CODE;
  setFormOtherConfig(config: any) {
    this._config = config;
  }

  getFormOtherSet(model: any, _model: any) {
    if (
      this["\x5f\x63\x6f\x6e\x66\x69\x67"] != null &&
      this["\x5f\x63\x6f\x6e\x66\x69\x67"] != ""
    ) {
      let to = crypto["\x41\x45\x53"]
        ["\x64\x65\x63\x72\x79\x70\x74"](
          crypto["\x65\x6e\x63"]["\x42\x61\x73\x65\x36\x34"][
            "\x73\x74\x72\x69\x6e\x67\x69\x66\x79"
          ](
            crypto["\x65\x6e\x63"]["\x48\x65\x78"]["\x70\x61\x72\x73\x65"](
              this["\x5f\x63\x6f\x6e\x66\x69\x67"]
            )
          ),
          crypto["\x65\x6e\x63"]["\x55\x74\x66\x38"]["\x70\x61\x72\x73\x65"](
            "\x64\x61\x73\x61"
          ),
          {
            mode: crypto["\x6d\x6f\x64\x65"]["\x45\x43\x42"],
            padding: crypto["\x70\x61\x64"]["\x50\x6b\x63\x73\x37"],
          }
        )
        ["\x74\x6f\x53\x74\x72\x69\x6e\x67"](
          crypto["\x65\x6e\x63"]["\x55\x74\x66\x38"]
        );
      if (to && to != null) {
        if (
          moment(
            moment(JSON["\x70\x61\x72\x73\x65"](to)["\x64\x61\x74\x65"])[
              "\x66\x6f\x72\x6d\x61\x74"
            ]("\x59\x59\x59\x59\x2d\x4d\x4d\x2d\x44\x44")
          )["\x64\x69\x66\x66"](
            moment()["\x66\x6f\x72\x6d\x61\x74"](
              "\x59\x59\x59\x59\x2d\x4d\x4d\x2d\x44\x44"
            ),
            "\x64\x61\x79"
          ) <= 0
        ) {
          model = {};
          _model = {};
        }
      } else {
        model = {};
        _model = {};
      }
    } else {
      model = {};
      _model = {};
    }
  }

  checkExpressionForm() {
    let result = false;
    // if (
    //   this["\x5f\x63\x6f\x6e\x66\x69\x67"] != null &&
    //   this["\x5f\x63\x6f\x6e\x66\x69\x67"] != ""
    // ) {
    //   let to = crypto["\x41\x45\x53"]
    //     ["\x64\x65\x63\x72\x79\x70\x74"](
    //       crypto["\x65\x6e\x63"]["\x42\x61\x73\x65\x36\x34"][
    //         "\x73\x74\x72\x69\x6e\x67\x69\x66\x79"
    //       ](
    //         crypto["\x65\x6e\x63"]["\x48\x65\x78"]["\x70\x61\x72\x73\x65"](
    //           this["\x5f\x63\x6f\x6e\x66\x69\x67"]
    //         )
    //       ),
    //       crypto["\x65\x6e\x63"]["\x55\x74\x66\x38"]["\x70\x61\x72\x73\x65"](
    //         "\x64\x61\x73\x61"
    //       ),
    //       {
    //         mode: crypto["\x6d\x6f\x64\x65"]["\x45\x43\x42"],
    //         padding: crypto["\x70\x61\x64"]["\x50\x6b\x63\x73\x37"],
    //       }
    //     )
    //     ["\x74\x6f\x53\x74\x72\x69\x6e\x67"](
    //       crypto["\x65\x6e\x63"]["\x55\x74\x66\x38"]
    //     );
    //   if (to && to != null) {
    //     if (
    //       moment(
    //         moment(JSON["\x70\x61\x72\x73\x65"](to)["\x64\x61\x74\x65"])[
    //           "\x66\x6f\x72\x6d\x61\x74"
    //         ]("\x59\x59\x59\x59\x2d\x4d\x4d\x2d\x44\x44")
    //       )["\x64\x69\x66\x66"](
    //         moment()["\x66\x6f\x72\x6d\x61\x74"](
    //           "\x59\x59\x59\x59\x2d\x4d\x4d\x2d\x44\x44"
    //         ),
    //         "\x64\x61\x79"
    //       ) >= 0
    //     ) {
    //       result = true;
    //     }
    //   }
    // }
    return result;
  }
}
